import { useAuth0 } from '@auth0/auth0-react'
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import './App.css';
// import './Tour.css';
//Components
import Navbar from './Components/Navbar/Navbar';
import AuthLogin from './authLogin';
// import { useTour } from '@reactour/tour'
import SearchBar from './Components/SearchBar/SearchBar';
import Button from './Components/Utils/Button/Button';
import Tooltip from "./Components/Utils/Tooltip/Tooltip";
// import NotificationItem from './Components/Notifications/NotificationItem';
import EvaluateArea from './Routes/Evaluate/EvaluateArea/EvaluateArea';
import DevelopArea from './Routes/Develop/DevelopArea/DevelopArea';
import RouteWrapper from './Components/Utils/RouteWrapper/RouteWrapper';
//Routes
import Dashboard from './Routes/Dashboard/Dashboard';
import Evaluate from './Routes/Evaluate/Evaluate';
import Improve from './Routes/Improve'
import ImprovementPlanView from './Routes/Improve/ImprovementPlanView/ImprovementPlanView';
import Develop from './Routes/Develop';
import Library from './Routes/Library';
import Resources from './Routes/Resources';
import Settings from './Routes/Settings';
import Account from './Routes/Account';
import QualityCalendar from './Routes/QualityCalendar';
import Analyse from './Routes/Analyse/Analyse';
import Portal from './Routes/Portal/Portal';
import { DrawerProvider } from './Components/SectionsDrawer/DrawerContext';
import ReduxTest from './Routes/ReduxTest';
import { RootState, useAppDispatch, useAppSelector } from './Redux/Store/Store';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { clearUser, setUser } from './Redux/Store/Slices/auth';
import TemplateEditor from './Routes/Portal/TemplateEditor/TemplateEditor';
import DefineFields from './Routes/Portal/TemplateEditor/DefineFields/DefineFields';
import DefineStructure from './Routes/Portal/TemplateEditor/DefineStructure/DefineStructure';
import SmartQuestions from './Routes/Portal/TemplateEditor/SmartQuestions/SmartQuestions';
import DefineQuestions from './Routes/Portal/TemplateEditor/DefineQuestions/DefineQuestions';
import AdditionalInformation from './Routes/Portal/TemplateEditor/AdditionalInformation/AdditionalInformation';
import { IsIncludedInTestClient } from './API/ClientInfo/ClientInfo';
import LoadingWrapper from './Components/Utils/Loading/LoadingWrapper';

import layout from './Modules/layout.module.css';
import DropDownList from './Components/Utils/DropDownList/DropDownList';
import { getAiPowered, getClient, getClientOptionsDropdown, getClientRolePermission, getDevelopEnabled, getGen3Enabled, setClient } from './Redux/Store/Slices/client';
import { ClientRolePermission, ClientRolePermissionType } from './Types/Roles/RolePermission';
import {IDropDownListItem} from "./Types/DropDownList/IDropDownListItem";
import MandateTemplate from './Routes/Portal/TemplateEditor/MandateTemplate/MandateTemplate';
import AdminControls from './Routes/AdminControls/AdminControls';
import MandateThirdPartyTemplate from './Routes/AdminControls/MandateThirdPartyTemplate/MandateThirdPartyTemplate';
import CreateTemplate from './Routes/AdminControls/CreateTemplate/CreateTemplate';
import ManageTemplates from './Routes/AdminControls/ManageTemplates/ManageTemplates';
import CurateResources from './Routes/Portal/CurateResources/CurateResources';
import LibraryLiteCutoff from './Routes/Portal/LibraryLiteCutoff/LibraryLiteCutoff';
import LibraryGen3 from './Routes/Portal/LibraryGen3/LibraryGen3';
import DeleteClient from './Routes/Portal/DeleteClient/DeleteClient';
import PortalLayout from './Routes/Portal/PortalLayout';
import { useAutoSwitchClient } from './Hooks/useAutoSwitchClient';
import { useBrowserTabTitle } from './Hooks/useBrowserTabTitle';
import { useMcpWarmup } from './Hooks/useMcpWarmup';
import ImproveTemplateCreation from './Routes/Portal/TemplateEditor/ImproveTemplateCreation/ImproveTemplateCreation';
import DevelopTemplateCreation from './Routes/Portal/TemplateEditor/DevelopTemplateCreation/DevelopTemplateCreation';
import { CrispChat } from './Components/Utils/Crisp/CrispChat';
import LegacyBlazorRedirect from './Components/Utils/LegacyBlazorRedirect/LegacyBlazorRedirect';

function App() {

  const { user, isAuthenticated, getIdTokenClaims, loginWithRedirect, logout } = useAuth0();
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  useBrowserTabTitle();
  
  // const { setIsOpen } = useTour();

  const client = useAppSelector(getClient);
  const clientRolePermission = useAppSelector(getClientRolePermission);
  const clientOptions = useAppSelector(getClientOptionsDropdown);
  const aiPowered = useAppSelector(getAiPowered);
  const gen3Enabled = useAppSelector(getGen3Enabled);
  const developEnabled = useAppSelector(getDevelopEnabled);
  
    // Check the Redux auth state
    const reduxAuth = useSelector((state: RootState) => state.auth);

    useEffect(() => {
      const setupUser = async () => {
        if (isAuthenticated && user) {
          try {
            const idTokenClaims = await getIdTokenClaims();
                         const userData = {
               id: user.sub || '', // Ensure `id` is never `undefined`
               sub: user.sub || '',
               crispId: '', // Additional data as needed
               archived: false,
               likedTemplateIds: [],
               email: user.email ?? '', // Use nullish coalescing in case `email` is undefined
               givenName: user.given_name,
               familyName: user.family_name,
               fullName: user.name,
               picture: user.picture,
               lastLogin: new Date(), // Replace with real data if tracking login time
               receiveEmails: true, // Adjust based on your data needs
             };
            dispatch(setUser(userData)); // Dispatch to Redux
          } catch (error) {
            console.error('Error fetching token claims:', error);
            dispatch(clearUser());
          }
        } else {
          dispatch(clearUser());
        }
      };
  
      setupUser();
    }, [isAuthenticated, user, dispatch, getIdTokenClaims]);  

  const data = ["Evalute", "Track", "Develop", "Library", "Resources", "Settings", "Admin"]

  
const [enabled, setEnabled] = useState<boolean | undefined>(undefined);


useEffect(() => {
  setEnabled(gen3Enabled);
}, [gen3Enabled]);

  // Auto-switch to last active client on load
  useAutoSwitchClient();

  // Pre-connect MCP as soon as an AI-powered client is known (before Analyse).
  useMcpWarmup();

  // Removed useEffect to prevent conflicts with manual client switching


  const onClientChanged = async (x: IDropDownListItem) => {
        if(user?.sub){
          navigate("/");
          dispatch(setClient({ userSub: user?.sub, clientId: x.value }));
        }
  }

  if (isAuthenticated && user) {
    return (
      <div className='wrapper'>
        <Navbar />
        <CrispChat/>
        <div className='container'>
          <div className='top-nav'>
            <div className='top-nav__left'>
              <DropDownList value={client?.id ?? ''} placeholder={'Select Client'} data={clientOptions} onChange={(x) => onClientChanged(x)}/>
                                                           <div style={{
                  backgroundColor: '#24394F',
                  color: 'white',
                  padding: '4px 8px',
                  borderRadius: '12px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  marginLeft: '12px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                <Tooltip text={`Mia will not be charged while in Beta`} align={'bottom'}>
                  <div className="beta-badge">
                    <p>Beta</p>
                    <img src="/img/sparkle-white.svg" alt="AI Sparkle" className="sparkle-icon" />
                  </div>
                </Tooltip>
              </div>
            </div>
            <div className='top-nav__right'>
              <div className="session-identity" title={user.email ?? undefined}>
                <span className="session-identity__name">{signedInName(user, reduxAuth.user)}</span>
                <span className="session-identity__role">{clientRoleLabel(clientRolePermission)}</span>
              </div>
              <Button clickHandler={() => logout({ logoutParams: { returnTo: window.location.origin } })} size="Icon" colour={"rgba(0,0,0,0"}>
                <img src='/img/NavIcons/logout.svg' />
              </Button>
              {/* <Button className='tour-button-container' clickHandler={() => setIsOpen(true)} size="Icon" colour={"rgba(0,0,0,0"}>
                <img src='/img/NavIcons/product.svg' />
              </Button> */}
              {/* <NotificationItem /> */}
            </div>
          </div>
          <div className="main">
            
            {enabled === true ? 
              <RouteWrapper>
              <Routes>

                <Route path="/" element={<Dashboard />} index />
                <Route path="/calendar" element={<QualityCalendar />} />

                <Route path="/evaluate" element={<Evaluate />}>
                  <Route path="active" />
                  <Route path="planned" />
                  <Route path="archive" />
                </Route>

                <Route path="evaluate/:areaId" element={<EvaluateArea />}>
                  <Route path=":sectionId/:criteriaId"/>
                  <Route path="create-improvement"/>
                  <Route path="scope"/>
                  <Route path="additional-info"/>
                </Route>

                <Route path="/portal/template-editor/:templateType/:templateId/:templateTitle/define-structure" element={<DefineStructure />} />

                <Route path="/portal/template-editor/:templateType/:templateId/:templateTitle/define-fields" element={<DefineFields />} />

                <Route path="/portal/template-editor/:templateType/:templateId/:templateTitle/define-questions" element={<DefineQuestions />} >
                  <Route path=':sectionId/:criteriaId'/>
                </Route>

                <Route path="/portal/template-editor/:templateType/:templateId/:templateTitle/additional-information" element={<AdditionalInformation />} />

                <Route path="/portal/template-editor/:templateType/:templateId/:templateTitle/mandate-template" element={<MandateTemplate />} />

                <Route path="/improve" element={<Improve />}>
                  <Route path="active" />
                  <Route path="archive" />
                </Route>
                <Route path="/improve/:planId" element={<ImprovementPlanView /> } />
                {developEnabled && (
                  <>
                    <Route path="/develop" element={<Develop />}>
                      <Route path="active" />
                      <Route path="archive" />
                    </Route>
                    <Route path="develop/:areaId" element={<DevelopArea />}>
                      <Route path=":sectionId/:criteriaId"/>
                      <Route path="create-improvement"/>
                      <Route path="scope"/>
                      <Route path="additional-info"/>
                    </Route>
                  </>
                )}
                <Route path="/library/*" element={<Library />} />
                <Route path="/resources" element={<Resources />} />

                {/* Notifications is legacy Blazor only — no Innovate page */}
                <Route path="/notifications" element={<LegacyBlazorRedirect blazorPath="/Notifications" />} />
                <Route path="/Notifications" element={<LegacyBlazorRedirect blazorPath="/Notifications" />} />
                
                <Route path="/template-editor/:templateType/:templateId/:templateTitle/define-structure" element={<DefineStructure />} />
                <Route path="/template-editor/:templateType/:templateId/:templateTitle/define-fields" element={<DefineFields />} />
                <Route path="/template-editor/:templateType/:templateId/:templateTitle/define-questions" element={<DefineQuestions />} >
                  <Route path=':sectionId/:criteriaId'/>
                </Route>
                <Route path="/template-editor/:templateType/:templateId/:templateTitle/additional-information" element={<AdditionalInformation />} />
                <Route path="/template-editor/:templateType/:templateId/:templateTitle/mandate-template" element={<MandateTemplate />} />
                <Route path="/template-editor/:templateType/:templateId/:templateTitle/improve-template-creation" element={<ImproveTemplateCreation />} />
                <Route path="/admin/template-editor/:templateType/:templateId/:templateTitle/improve-template-creation" element={<ImproveTemplateCreation />} />
                <Route
                  path="/admin/create-a-template/:templateType/:templateId/:templateTitle/improve-template-creation"
                  element={<ImproveTemplateCreation />}
                />
                <Route path="/template-editor/:templateType/:templateId/:templateTitle/develop-template-creation" element={<DevelopTemplateCreation />} />
                <Route path="/admin/template-editor/:templateType/:templateId/:templateTitle/develop-template-creation" element={<DevelopTemplateCreation />} />
                <Route
                  path="/admin/create-a-template/:templateType/:templateId/:templateTitle/develop-template-creation"
                  element={<DevelopTemplateCreation />}
                />
                
                <Route element={<PortalLayout />}>
                  <Route path="/template-editor" element={<TemplateEditor />}>
                    <Route path="active" />
                    <Route path="archive" />
                  </Route>
                  <Route path="/portal/curate-resources" element={<CurateResources />} />
                  <Route path="/portal/library-lite-cutoff" element={<LibraryLiteCutoff />} />
                  <Route path="/portal/library-rollout" element={<LibraryGen3 />} />
                  <Route path="/portal/delete-client" element={<DeleteClient />} />
                </Route>
  
                <Route path="/settings" element={<Settings />} />
                <Route path="/account" element={<Account />} />
                <Route path="/analyse" element={<Analyse />} />
                <Route path="/analyse/chat/:chatId" element={<Analyse />} />

                <Route
                  path="/admin/curate-resources"
                  element={<Navigate to="/portal/curate-resources" replace />}
                />

                <Route path="/admin" element={<AdminControls />}>
                  <Route index element={<Navigate to="manage-templates/active" replace />} />
                  <Route path="mandate-templates" element={<MandateThirdPartyTemplate />} />
                  <Route path="create-a-template" element={<CreateTemplate />} />
                  <Route path="manage-templates/*" element={<ManageTemplates />} />
                  <Route path="preferences" element={<Navigate to="/admin/manage-templates/active" replace />} />
                </Route>

                <Route path="/admin/create-a-template/:templateType/:templateId/:templateTitle/define-fields" element={<DefineFields />} />
                <Route path="/admin/create-a-template/:templateType/:templateId/:templateTitle/define-structure" element={<DefineStructure />} />
                <Route path="/admin/create-a-template/:templateType/:templateId/:templateTitle/define-questions" element={<DefineQuestions />} >
                  <Route path=':sectionId/:criteriaId'/>
                </Route>
                <Route path="/admin/create-a-template/:templateType/:templateId/:templateTitle/additional-information" element={<AdditionalInformation />} />
                <Route path="/admin/create-a-template/:templateType/:templateId/:templateTitle/mandate-template" element={<MandateTemplate />} />

              </Routes>
              </RouteWrapper>
            :
              <LoadingWrapper loading={enabled === undefined}>
                <div className={layout.padding30}>
                  <p>{client?.name} is not enabled for the Mesma Beta. Please contact support for assistance.</p>
                </div>
              </LoadingWrapper>
            }
            
          </div>
        </div>
      </div >
    );
  } else {
    return <AuthLogin />
  }

}

const clientRoleLabels: Record<ClientRolePermissionType, string> = {
  [ClientRolePermissionType.SuperAdmin]: "Super admin",
  [ClientRolePermissionType.AdvancedAdmin]: "Advanced admin",
  [ClientRolePermissionType.ClientAdmin]: "Client admin",
  [ClientRolePermissionType.ClientOwner]: "Standard user",
  [ClientRolePermissionType.MesmaAdmin]: "Mesma admin",
  [ClientRolePermissionType.StandardUser]: "Standard user",
  [ClientRolePermissionType.DepartmentOwner]: "Department owner",
  [ClientRolePermissionType.PartnerOwner]: "Partner owner",
};

const signedInName = (
  user: { name?: string; given_name?: string; family_name?: string; email?: string; nickname?: string },
  stored?: { givenName?: string; familyName?: string; fullName?: string } | null
) => {
  const given = user.given_name?.trim() || stored?.givenName?.trim();
  const family = user.family_name?.trim() || stored?.familyName?.trim();
  const name = [given, family].filter(Boolean).join(" ")
    || stored?.fullName?.trim()
    || user.name?.trim()
    || user.nickname?.trim()
    || user.email?.trim();
  return name || "Signed in";
};

const clientRoleLabel = (role: ClientRolePermission | undefined) => {
  if (!role) return "Role loading";
  if (role.permissionType === ClientRolePermissionType.ClientOwner) {
    return clientRoleLabels[ClientRolePermissionType.StandardUser];
  }
  const title = role.roleTitle?.trim();
  if (title) return title;
  return clientRoleLabels[role.permissionType] ?? "Unknown role";
};

export default App;
